export default "__VITE_ASSET__5935e986__"